import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle', 'menu']
  static classes = ['open']

  connect () {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  disconnect () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  toggle () {
    this.menuTarget.classList.toggle('d-none')
  }

  close () {
    this.menuTarget.classList.add('d-none')
  }

  handleClickOutside (event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
